import * as React from "react";
import { cn } from "../../lib/utils";
import { ChevronRight } from "lucide-react";

const Breadcrumb = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <nav
        ref={ref}
        aria-label="breadcrumb"
        className={cn(
          "flex items-center text-sm text-muted-foreground",
          className
        )}
        {...props}
      />
    );
  }
);
Breadcrumb.displayName = "Breadcrumb";

const BreadcrumbList = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ol
        ref={ref}
        className={cn("flex flex-wrap items-center gap-1.5", className)}
        {...props}
      />
    );
  }
);
BreadcrumbList.displayName = "BreadcrumbList";

const BreadcrumbItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <li
        ref={ref}
        className={cn("inline-flex items-center gap-1.5", className)}
        {...props}
      />
    );
  }
);
BreadcrumbItem.displayName = "BreadcrumbItem";

const BreadcrumbSeparator = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <li
        ref={ref}
        aria-hidden="true"
        className={cn("flex items-center", className)}
        {...props}
      >
        {children || <ChevronRight className="h-3 w-3" />}
      </li>
    );
  }
);
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

const BreadcrumbLink = React.forwardRef(
  ({ className, asChild, ...props }, ref) => {
    return (
      <a
        ref={ref}
        className={cn("transition-colors hover:text-foreground", className)}
        {...props}
      />
    );
  }
);
BreadcrumbLink.displayName = "BreadcrumbLink";

const BreadcrumbPage = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <span
        ref={ref}
        aria-current="page"
        className={cn("font-medium text-foreground", className)}
        {...props}
      />
    );
  }
);
BreadcrumbPage.displayName = "BreadcrumbPage";

export {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbLink,
  BreadcrumbPage,
};
